module.exports = __webpack_public_path__ + "img/19_37.5a0fef28.png";